<template>
  <div class="container bottom-fix-padding">
    <div class="navi">
        <span class="icon-arrow-left" @click="goback()"></span>
    </div>
    
    <div class="title">请确认订单详情</div>

    <img class="prepay-img" src='../../assets/img/other/prepay-amount.png'>

      <div class="weui-cells__title">服务详情，点击可修改</div>
      <div class="weui-cells">

        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/pest-step5')">
            <div class="weui-cell__bd">
                <p>服务时间</p>
            </div>
            <div class="weui-cell__ft">{{order.data.service_date | moment("YYYY年M月D日")}} {{service_period}}</div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/pest-step4')">
            <div class="weui-cell__bd">
                <p>服务地址</p>
            </div>
            <div class="weui-cell__ft">{{order.data.address_street}}, {{order.data.address_suburb}}, {{order.data.address_state}}, {{order.data.address_postcode}}</div>
        </a>

      </div>
      <!-- 退房除虫 独立除虫 开始 -->
      <div class="weui-cells" v-if="!order.data.pest_standard || order.data.house_status=='3'">
        <a class="weui-cell" href="javascript:;">
            <div class="weui-cell__bd">
                <p>服务类型</p>
            </div>
            <div class="weui-cell__ft">除虫除鼠</div>
        </a>

        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/pest-step2')" v-if="order.data.house_status=='1'">
            <div class="weui-cell__bd">
                <p>除虫详情</p>
            </div>
            <div class="weui-cell__ft">
              <span v-if="order.data.pest_standard">一般害虫</span>
              <span v-if="order.data.pest_standard && (order.data.pest_mouse || order.data.pest_german)">+</span>
              <span v-if="order.data.pest_mouse">除鼠</span>
              <span v-if="order.data.pest_mouse && order.data.pest_german">+</span>
              <span v-if="order.data.pest_german">德国小蠊</span>
            </div>
        </a>

        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/pest-step2-moveout')" v-if="order.data.house_status=='3'">
            <div class="weui-cell__bd">
                <p>除虫详情</p>
            </div>
            <div class="weui-cell__ft" v-if="!order.data.pest_mouse">
              <span>退房除虫套餐A</span>
            </div>
            <div class="weui-cell__ft" v-else>
              <span>退房除虫套餐B (含除鼠）</span>
            </div>
        </a>


      </div>
      <!-- 退房除虫 独立除虫 结束 -->



      <div class="weui-cells" v-else>

        <!-- 一般除虫 house 开始 -->
        <template  v-if="order.data.house_type=='house'">

          <a class="weui-cell  weui-cell_access" href="javascript:;"  @click="editData('/pest-step3-house')">
              <div class="weui-cell__bd">
                  <p > 整屋除虫 </p>
              </div>
              <div class="weui-cell__ft"><span >{{order.data.house_type | titlecase}} {{order.data.room_qty}}房</span> </div>
          </a>

          <a class="weui-cell  weui-cell_access" href="javascript:;"  @click="editData('/pest-step3-house')">
              <div class="weui-cell__bd">
                  <p> 
                    房产面积
                  </p>
              </div>
              <div class="weui-cell__ft">
                  <span  v-if="order.data.extra_area=='0'">600㎡以下</span>
                  <span  v-if="order.data.extra_area=='1'">600～1000㎡</span>
                  <span  v-if="order.data.extra_area=='2'">600～1000㎡</span>
              </div>
          </a>


          <a class="weui-cell  weui-cell_access" href="javascript:;"  @click="editData('/pest-step3-house')">
              <div class="weui-cell__bd">
                  <p> 
                    Granny Flat 
                  </p>
              </div>
              <div class="weui-cell__ft">
                    <span  v-if="order.data.extra_granny=='0'">不包含</span>
                    <span  v-if="order.data.extra_granny=='1'">单间房</span>
                    <span  v-if="order.data.extra_granny=='2'">多间房</span>
              </div>
          </a>

          <a class="weui-cell  weui-cell_access" href="javascript:;"  @click="editData('/pest-step2')" v-show="order.data.pest_mouse || order.data.pest_german ">
              <div class="weui-cell__bd">
                  <p>额外项目</p>
              </div>
              <div class="weui-cell__ft">
                <span  v-if="order.data.pest_mouse">除鼠</span>
                <span  v-if="order.data.pest_mouse && order.data.pest_german">+</span>
                <span  v-if="order.data.pest_german">德国小蠊</span>
              </div>
          </a>

        </template>

        <!-- 一般除虫 house 结束 -->

        <!-- 一般除虫 非house 开始 -->
        <template  v-else>
          <a class="weui-cell  weui-cell_access" href="javascript:;"  @click="editData('/pest-step3')" >
              <div class="weui-cell__bd">
                  <p> 一般害虫 【 {{order.data.house_type | titlecase}} {{order.data.room_qty}}房 】</p>
              </div>
              <div class="weui-cell__ft">{{calHousePrice(order.data.house_type,order.data.room_qty) | numeral('$0,0.00')}}</div>
          </a>


          <a class="weui-cell  weui-cell_access" href="javascript:;"  @click="editData('/pest-step2')" v-show="order.data.pest_mouse || order.data.pest_german ">
              <div class="weui-cell__bd">
                  <p>
                    <span v-if="order.data.pest_mouse">除鼠</span>
                    <span v-if="order.data.pest_mouse && order.data.pest_german">+</span>
                    <span v-if="order.data.pest_german">德国小蠊</span>
                  </p>
              </div>
              <div class="weui-cell__ft" v-if="this.order.data.pest_mouse">{{120 | numeral('$0,0.00')}}</div>
              <div class="weui-cell__ft" v-else>{{80 | numeral('$0,0.00')}}</div>
          </a>
        </template>
        <!-- 一般除虫 非house 结束 -->


      </div>


      <div class="weui-cells__title">优惠码</div>
      <div class="weui-cells coupon-cell">
        <a class="weui-cell weui-cell_access" href="javascript:;" @click="editData('/coupon-apply')">
            <div class="weui-cell__bd">
                <p>优惠券</p>
            </div>
            <div class="weui-cell__ft" v-if="order.data.coupon_id">{{order.data.coupon_title | uppercase}}</div>
            <div class="weui-cell__ft" v-else> <span class="icon-coupon"></span> 点击使用 </div>
        </a>
      </div>


      <div class="weui-cells__title">留言备注</div>
      <div class="weui-cells weui-cells_form">
          <div class="weui-cell">
              <div class="weui-cell__bd">
                  <textarea class="weui-textarea" placeholder="如果有特殊需求，请在此备注留言" rows="2"  v-model="order.data.msg"></textarea>
              </div>
          </div>
      </div>

      <div class="btn-box-fix">
        <div class="btn-container">
          <div class="btn active" @click="isSubmiting=true">创建订单</div>
        </div>
      </div>
      <div class="js_dialog" v-show="isSubmiting">
          <div class="weui-mask"></div>
          <div class="weui-dialog">
              <div class="weui-dialog__hd"><strong class="weui-dialog__title">温馨提醒</strong></div>
              <div class="weui-dialog__bd">请确保服务信息无误，提交后信息将被锁定，只能联系客服修改</div>
              <div class="weui-dialog__ft">
                  <div  class="weui-dialog__btn weui-dialog__btn_default" @click="isSubmiting=false">关闭</div>
                  <div class="weui-dialog__btn weui-dialog__btn_daojia" @click="submitOrder()">确定提交</div>
              </div>
          </div>
      </div>


      <transition name="fade">
          <div id="loadingToast" v-show="isSending">
              <div class="weui-mask_transparent"></div>
              <div class="weui-toast">
                  <i class="weui-loading weui-icon_toast"></i>
                  <p class="weui-toast__content">正在提交</p>
              </div>
          </div>
      </transition>
      <img :src="pixelURL('clean','xiadan')" class="hide">
    </div>
</template>

<script>
import qs from 'qs'
import Vue from 'vue'

export default {
  name: 'finalStep',
  data () {
    return {
      order:{},
      isSending:false,
      isSubmiting:false,
      pricing:{},
    }
  },
  methods: {

    calHousePrice(type,room){

      let roomPrice = 0;

      if(type=="house"){
        let areaPrice = 0;
        let grannyPrice = 0;

        if(room<=3){
          roomPrice = 190;
        }
        if(room==4){
          roomPrice = 220;
        }
        if(room==5){
          roomPrice = 240;
        }
        if(room>=6){
          roomPrice = 260;
        }
      }

      if(type=="townhouse"){
        if(room<=2){
          roomPrice = 155;
        }
        if(room==3){
          roomPrice = 180;
        }
        if(room==4){
          roomPrice = 190;
        }
        if(room>=5){
          roomPrice = 220;
        }
      }

      if(type=="apartment"){
        if(room==1){
          roomPrice = 130;
        }
        if(room==2){
          roomPrice = 140;
        }
        if(room>=3){
          roomPrice = 160;
        }
      }

      if(type=="studio"){
          roomPrice = 120;
      }
      return roomPrice;


    },
    editData(url){
      localStorage.isEditing = '/pest-step6';
      this.$router.push(url);
    },
    goback(){
      if(this.$route.query.src == 'order'){
        this.$router.push('/order');
      }
      else{
        this.$router.push('/pest-step5');
      }
    },

    submitOrder(){
      this.isSubmiting = false;
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        this.orderUpdate('msg',this.order.data.msg)

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.order.data));

        orderObject.type_id = 1550735981;

        if(this.checkLogin()){
            orderObject.token = localStorage.token;
            orderObject.member_name = localStorage.member_name;
            orderObject.member_phone = localStorage.member_phone;
            orderObject.member_mail = localStorage.member_mail;
        }
        else{
            orderObject.token = 0;
            orderObject.member_name = orderObject.address_name;
            orderObject.member_phone = orderObject.address_phone;
        }

        orderObject.service_date = new Date(orderObject.service_date);
        orderObject.service_date = Vue.filter('moment')(orderObject.service_date,"YYYY-MM-DD");
        
        orderObject['order_source'] = '3';

        if(orderObject.house_status=='3'){
          orderObject.pest_type = '3';

          if(orderObject.pest_mouse){
            orderObject.purge_type = 1627094997;
          }
          else{
            orderObject.purge_type = 1627094973;
          }
        }
        else{
          if(!orderObject.pest_standard){
            orderObject.pest_type = '2';

            if(orderObject.pest_german && !orderObject.pest_mouse){
              orderObject.purge_type = 1626848724;
            }

            if(!orderObject.pest_german && orderObject.pest_mouse){
              orderObject.purge_type = 1626848743;
            }

            if(orderObject.pest_german && orderObject.pest_mouse){
              orderObject.purge_type = 1626848758;
            }

          }
          else{
            orderObject.pest_type = '1';

          }
        }


        if(orderObject.pest_type == '1'){

          if(orderObject.house_type=="house"){
            orderObject.house_type = 1626845872;
            if(orderObject.room_qty<=3){
              orderObject.room_type = 1626846938;
            }
            if(orderObject.room_qty==4){
              orderObject.room_type = 1626846949;
            }
            if(orderObject.room_qty==5){
              orderObject.room_type = 1626846972;
            }
            if(orderObject.room_qty>=6){
              orderObject.room_type = 1626847274;
            }
            if(!orderObject.pest_german && !orderObject.pest_mouse){
              orderObject.purge_type = 1628477068;
            }
            if(orderObject.pest_german && !orderObject.pest_mouse){
              orderObject.purge_type = 1626848127;
            }
            if(!orderObject.pest_german && orderObject.pest_mouse){
              orderObject.purge_type = 1626848154;
            }
            if(orderObject.pest_german && orderObject.pest_mouse){
              orderObject.purge_type = 1626848167;
            }


            if(orderObject.extra_area=="0"){
              orderObject.area_type = 1626850679;
            }
            if(orderObject.extra_area=="1"){
              orderObject.area_type = 1626850719;
            }
            if(orderObject.extra_area=="2"){
              orderObject.area_type = 1626850741;
            }

            if(orderObject.extra_granny=="0"){
              orderObject.other_type = 1626850772;
            }
            if(orderObject.extra_granny=="1"){
              orderObject.other_type = 1626850788;
            }
            if(orderObject.extra_granny=="2"){
              orderObject.other_type = 1626850799;
            }

          }

          if(orderObject.house_type=="townhouse"){
            orderObject.house_type = 1626845903;
            if(orderObject.room_qty<=2){
              orderObject.room_type = 1626847353;
            }
            if(orderObject.room_qty==3){
              orderObject.room_type = 1626847385;
            }
            if(orderObject.room_qty==4){
              orderObject.room_type = 1626847398;
            }
            if(orderObject.room_qty>=5){
              orderObject.room_type = 1626847411;
            }
            if(!orderObject.pest_german && !orderObject.pest_mouse){
              orderObject.purge_type = 1628477127;
            }
            if(orderObject.pest_german && !orderObject.pest_mouse){
              orderObject.purge_type = 1626848292;
            }
            if(!orderObject.pest_german && orderObject.pest_mouse){
              orderObject.purge_type = 1626848298;
            }
            if(orderObject.pest_german && orderObject.pest_mouse){
              orderObject.purge_type = 1626848306;
            }
          }

          if(orderObject.house_type=="apartment"){
            orderObject.house_type = 1626845849;
            if(orderObject.room_qty==1){
              orderObject.room_type = 1626846771;
            }
            if(orderObject.room_qty==2){
              orderObject.room_type = 1626846804;
            }
            if(orderObject.room_qty>=3){
              orderObject.room_type = 1626846824;
            }
            if(!orderObject.pest_german && !orderObject.pest_mouse){
              orderObject.purge_type = 1628477163;
            }
            if(orderObject.pest_german && !orderObject.pest_mouse){
              orderObject.purge_type = 1626848415;
            }
            if(!orderObject.pest_german && orderObject.pest_mouse){
              orderObject.purge_type = 1627264822;
            }
            if(orderObject.pest_german && orderObject.pest_mouse){
              orderObject.purge_type = 1627264832;
            }
          }

          if(orderObject.house_type=="studio"){
            orderObject.house_type = 1626845914;
            orderObject.room_type = 1626847558;
            if(!orderObject.pest_german && !orderObject.pest_mouse){
              orderObject.purge_type = 1628477136;
            }
            if(orderObject.pest_german && !orderObject.pest_mouse){
              orderObject.purge_type = 1626848521;
            }
            if(!orderObject.pest_german && orderObject.pest_mouse){
              orderObject.purge_type = 1627264861;
            }
            if(orderObject.pest_german && orderObject.pest_mouse){
              orderObject.purge_type = 1627264867;
            }
          }
        }


        if(orderObject.pest_standard){
          orderObject.pest_standard = 1;
        }
        else{
          orderObject.pest_standard = 0;
        }

        if(orderObject.pest_german){
          orderObject.pest_german = 1;
        }
        else{
          orderObject.pest_german = 0;
        }

        if(orderObject.pest_mouse){
          orderObject.pest_mouse = 1;
        }
        else{
          orderObject.pest_mouse = 0;
        }
        
        console.log(orderObject);

        this.axios.post(this.apiURL()+'/Order/createOrder', qs.stringify(orderObject))
        .then(function (response) {
          console.log(response);
          if(response.data.error_code==0){
            localStorage.removeItem('order');

            that.$router.push('/order-prepay?id='+response.data.data.order_number+'&status=0&amount='+that.depositAmount());
            if(response.data.data.accoun_status>=0){
              localStorage.account_status = response.data.data.accoun_status;
            }
            if(response.data.data.accoun_status == 2){
              localStorage.token = response.data.data.token;
              localStorage.member_phone = response.data.data.phone;
              localStorage.member_name = response.data.data.name;
              localStorage.tempPasswd = response.data.data.password;
            }
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },

  },
  components: {
  },
  computed: {
    service_period: function () {
      let result = '';
      switch (this.order.data.service_period) {
        case "am":
          result = '上午'
          break;
        case "pm":
          result = '下午'
          break;

        default:
      }
      return result;
    },
    est_price: function () {
      let result = '';
      if(this.order.data.house_status=='3'){
        if(this.order.data.pest_mouse){
          return 110;
        }
        else{
          return 99;
        }
      }
      else{
        if(!this.order.data.pest_standard){
          if(this.order.data.pest_german){
            return 200;
          }
          else{
            return 180;
          }
        }
      }
      return result;
    },
  },
  created: function () {
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "pest"){
        this.order = localParsed;
        this.userCatch(this.order.data.type_id,this.order.data.address_name,this.order.data.address_phone,true);
      }
      else{
        this.$router.push('/');
      }
    }
    else{
      this.$router.push('/');
    }
  },
  mounted: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ .weui-cell__ft{
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width:70%;
  font-size:0.9em;
}

.mini-title{
  margin-top:20px;
  color: #595D68;
  font-size: 12pt;
  text-align: center;
  font-weight: bold;
}

.park-assist{
    text-align:center;
    color:#fe9567;
}

.prepay-img{
  width:100%;
}

.container /deep/{

  .couponPd{
    padding-top:0;
    padding-bottom:0;
  }

  .weui-vcode-btn{
    padding-right:0;
    margin-left:10px;
    color:#ff7444;
  }

  .weui-cell_access .weui-cell__ft:after{
    border-color: #FE956A;
  }

}
</style>



// WEBPACK FOOTER //
// src/pages/pest/step6.vue